import React from "react";
import Form from "react-bootstrap/Form";

const SwInput = ({
  type = "text",
  placeholder = "",
  className = "",
  value,
  defaultValue,
  onChange,
  ...rest
}) => {
  return (
    <Form.Control
      type={type}
      placeholder={placeholder}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      className={`SwFormText ${className}`}
      {...rest}
    />
  );
};

export default SwInput;
